import React from "react";
import { formatMoney, treasuryToneClass } from "./treasuryHelpers";

export default function TreasuryCoverageHero({
  coverage,
  providerBalance,
  currency,
  coverPct,
  generatedAt,
}) {
  const toneClass = treasuryToneClass(coverage?.tone);
  const gapAbs = Math.abs(Number(coverage?.gap) || 0);
  const gapPrefix = Number(coverage?.gap) >= 0 ? "+" : "−";

  return (
    <section className={`atrs-summary ${toneClass}`} aria-label="Treasury overview">
      <div className="atrs-summary-status">
        <p className="atrs-section-kicker">Treasury health</p>
        <div className="atrs-summary-heading">
          <h2>{coverage?.label || "—"}</h2>
          <span className={`atrs-status-pill ${toneClass}`}>
            {coverage?.ratio == null ? "—" : `${coverPct}%`} covered
          </span>
        </div>
        <p className="atrs-summary-copy">
          Provider float measured against all user and escrow obligations.
        </p>
        {generatedAt ? (
          <p className="atrs-summary-stamp">
            Last updated{" "}
            {new Date(generatedAt).toLocaleString(undefined, {
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </p>
        ) : null}
      </div>

      <dl className="atrs-summary-values">
        <div>
          <dt>Provider float</dt>
          <dd className="tabular-nums">
            {formatMoney(providerBalance, { currency: currency || "RWF", compact: true })}
          </dd>
        </div>
        <div>
          <dt>Total obligations</dt>
          <dd className="tabular-nums">
            {formatMoney(coverage?.obligations, { currency: "CASH", compact: true })}
          </dd>
        </div>
        <div>
          <dt>{Number(coverage?.gap) >= 0 ? "Surplus" : "Shortfall"}</dt>
          <dd className={`tabular-nums ${toneClass}`}>
            {gapPrefix}
            {formatMoney(gapAbs, { currency: currency || "RWF", compact: true })}
          </dd>
        </div>
      </dl>

      <div className="atrs-coverage-bar" aria-label={`${coverPct}% coverage`}>
        <span style={{ width: `${Math.min(coverPct, 100)}%` }} />
      </div>
    </section>
  );
}
